<template>
  <div class="achievementFee">
    <el-form ref="form" >
      <el-row>
        <div class="topTitle">业绩提成设置</div>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="8" v-for="(i,index) in form" :key='index'>
          <div class="royalty">
            <!-- 岗位（调理、店长、顾问、收银、财务） -->
            <span class="tag">{{i.postId | filterPostId(infolist.postIdData) | filterRow}}</span>
            <div class="list" @click="linkTo(i)">
                <b class="title">{{i.feeName}}</b>
                <div class="info">提成类型：{{i.isTeam == 1 ?'团队提成':'个人提成'}}</div>
                <div class="info">提成来源：{{sourceType(i.sourceList)}}</div>
                <div class="info">
                  月度收入范围：
                </div>
                <div class="royaltyFee">
                    <!-- 月度业绩范围（只展示两个阶段） -->
                    <el-row v-for='(m,listindex) in i.detailList' :key="'achievement-'+listindex">
                      <template v-if='listindex < 2'>
                        <el-col :span='18'>{{m.bottom}}{{(listindex == i.detailList.length-1)?'+':'-'}}{{m.top == 10000000 ? '':m.top}}</el-col>
                        <el-col :span='6'>{{m.feeFactor}}%</el-col>
                      </template>
                    </el-row>
                  </div>
            </div>
            <el-row class="operation" @click.native='editToCommission(i)'>修改</el-row>
          </div>
        </el-col>
        <el-col :span='8'>
          <div class="royalty addRoyalty" @click='dialogRoyalty'>
            <span>+ 新增提成</span>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="查看提成" :visible.sync="dialogTableVisible" :center="true" width="700px">
      <commission :cueRowData='cueRowData'/>
    </el-dialog>

    <el-dialog :title="cueRowData?'修改提成':'新增提成'" :visible.sync="dialogRoyaltyVisible" :center="true" width="700px" :before-close="handleClose">
      <editCommission @closeDialog="closeDialog" :cueRowData='cueRowData' :openFlag="openFlag" :dialogRoyaltyVisible='dialogRoyaltyVisible'/>
    </el-dialog>

  </div>
</template>
<script>
import { queryStoreFeeList } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}
import commission from './commission'
import editCommission from './editCommission'

export default {
  components:{
    commission,editCommission
  },
  data() {
    return {
      infolist:infolist,
      form: {},
      dialogTableVisible:false,
      dialogRoyaltyVisible:false,
      cueRowData:'',
      openFlag:false,
    };
  },
  created() {
    this.detailInfo();
  },
  computed: {
    sourceType(){
      return function(val){
        let data = [];
        if(val){
          for(let i of val){
            if(i.sourceId && data.indexOf(i.sourceId) == -1){
              data.push(vFilter.filterScorce(i.sourceId));
            }
          }
        }
        return data.length ? data.join('、'):'无';
      }
    }
  },
  methods: {
    detailInfo() {
      queryStoreFeeList({
        feeType:1
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
        }
      });
    },
    closeDialog(val) {
      this.dialogTableVisible = val;
      this.dialogRoyaltyVisible = val;
      this.openFlag = true;
      this.detailInfo();
    },
    handleClose() {
      // 弹框数据清空
      this.closeDialog(false);
    },
    linkTo(val){
      // 查看详情
      this.dialogTableVisible = true;
      this.cueRowData = val;
    },
    dialogRoyalty(){
      this.dialogRoyaltyVisible = true;
      this.openFlag = false;
      this.cueRowData = '';
    },
    editToCommission(val){
      this.dialogRoyaltyVisible = true;
      this.openFlag = false;
      this.cueRowData = val;
    }
  }
};
</script>
<style lang="less" scoped>
.achievementFee {
  width: 100%;
  overflow: hidden;
  padding: 100px 50px 70px;
  position: relative;
  .royalty {
    border-radius: 4px;
    // height: 200px;
    overflow:hidden;
    border: 1px solid #d5d9e3;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    position: relative;
    margin-bottom: 30px;
    cursor:pointer;
    .tag{
        width: 35px;
        color: #fff;
        background: #2ECFA7;
        position: absolute;
        left: 15px;
        padding: 0 10px 10px 10px;
        border-radius: 0 0 18px 18px;
    }
    .list{
        b.title{
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          color: #000
        }
        padding: 20px 5% 10px 60px;
        color: #948F8F;
        line-height: 24px;
        .royaltyFee{
          margin: 0 0 0 1em;
          min-height: 47px;
          word-wrap: break-word;
          word-break: break-all;
        }
    }
    .operation{
      background: #F7F8FA;
      color: #948F8F;
      text-align: center;
      height: 45px;
      line-height: 45px;
      border-top: 1px solid #d5d9e3;
    }
    &.addRoyalty{
      border: 1px dashed #d5d9e3;
      box-shadow: none;
      text-align: center;
      line-height: 200px;
      span{
        color: #948F8F
      }
    }
  }
  .topTitle {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 28px;
  }
}
</style>
<style lang="less">
.achievementFee {
  .el-dialog__title {
    font-weight: bold;
  }
  .btnOptions {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/components/basicDataCenter/achievementFee.vue